import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../public/font/iconfont.css'
import './theme/index.less'
import './style/base.scss'

import {
    Button,
    Input,
    Radio,
    Checkbox,
    Row,
    Col,
} from 'iview'

Vue.component('Button', Button)
Vue.component('Input', Input)
Vue.component('Radio', Radio)
Vue.component('Checkbox', Checkbox)
Vue.component('Row', Row)
Vue.component('Col', Col)

Vue.directive('range', {
    inserted(el) {
        const setStyle = (r) => {
            const min = el.getAttribute('min') || 0
            const max = el.getAttribute('max') || 100
            const ran = Number(max) - Number(min)
            const val = (Number(r) / ran) * 100
            el.style = `background:linear-gradient(to right, #059CFA, #d9dadb ${val}%, #d9dadb)`
        }
        setStyle(el.value)
    },
    update(el) {
        const setStyle = (r) => {
            const min = el.getAttribute('min') || 0
            const max = el.getAttribute('max') || 100
            const ran = Number(max) - Number(min)
            const val = (Number(r) / ran) * 100
            el.style = `background:linear-gradient(to right, #059CFA, #d9dadb ${val}%, #d9dadb)`
        }
        setStyle(el.value)
    }
})
Vue.directive('active', {
    inserted(el) {
        const val = parseInt(el.innerText)
        if (val > 0) {
            el.setAttribute('class', 'top')
        } else {
            el.setAttribute('class', '')
        }
    },
    update(el) {
        const val = parseInt(el.innerText)
        if (val > 0) {
            el.setAttribute('class', 'top')
        } else {
            el.setAttribute('class', '')
        }
    }
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
